





























import {Component, Vue} from 'vue-property-decorator';
import {MedTransGoConstants} from '../../util/constants';
import {ApiRequest, QueryRecordsRequest, UpdateOrgRequest} from '../../types/request';
import {ObjectFactory} from '../../config/objectFactory';
import {Organization} from '../../types/entity';
import {CommonUtils} from '../../util/commonUtils';
import {ToastEvent} from '../../types/event';
import {EventBus} from '../../main';
import {required} from 'vuelidate/lib/validators';
import {ModelSelect} from 'vue-search-select';
import {Condition} from '@/types/queryRequest';
import {DriverProfile} from '@/types/response';

@Component({
    props: {
        id: String,
    },
    components: {
        ModelSelect,
    },
    validations: {
        driverId: {
            required,
        },
    },
    data() {
        return {
            driverId: '',
            options: [],
        };
    },
})
export default class BlockDriverModal extends Vue {
    private show = false;
    private drivers: DriverProfile[] | undefined = [];

    public mounted() {
        this.getDriversList();
        this.show = true;
    }

    private close() {
        this.$emit('close');
    }

    private async blockDriver() {
      const iHttpService = ObjectFactory.getHttpService();
      const updateRequest: UpdateOrgRequest = {
        blockDriverId: this.$data.driverId,
      };
      const apiRequest: ApiRequest = {
        baseURL: this.$store.state.serverUrl,
        url: `${MedTransGoConstants.HTTP_URL_ORGANIZATIONS}/${this.$props.id}/update`,
        data: updateRequest,
        loaderEvent: {
          show: true,
        },
      };
      const response = await iHttpService.put<Organization>(apiRequest);
      if (response) {
        const toastEvent: ToastEvent = {
          message: 'Transporter blocked successfully..',
          title: 'Success',
          varient: 'success',
          timeout: 5000,
        };
        EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        this.close();
      } else {
        CommonUtils.showError(response);
        this.close();
      }
    }

    private async getDriversList() {
      const organizationRes = await ObjectFactory.getOrganizationService().
      getOrgDetailsById(this.$store.state.serverUrl);
      const organization = organizationRes.data;

      const conditions: Condition[] = [];

      if (organization && organization.blockedDrivers && organization.blockedDrivers.length > 0) {
        conditions.push({
          op: 'nin',
          fieldName: 'userId',
          value: organization.blockedDrivers,
        });
      }

      const queryRecordsRequest: QueryRecordsRequest = {
        limit: MedTransGoConstants.DB_QUERY_MAX_RESULT,
        conditions,
      };

      const apiRequest: ApiRequest = {
        baseURL: this.$store.state.serverUrl,
        data: queryRecordsRequest,
        url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/drivers`,
        loaderEvent: {
          show: true,
        },
      };
      const iHttpService = ObjectFactory.getHttpService();
      const response = await iHttpService.post<DriverProfile[]>(apiRequest);
      if (response.success && response.data) {
        this.$data.options = [];
        this.drivers = response.data as DriverProfile[];
        response.data.forEach((element) => {
          const option = {
            value: element.id,
            text: `${element.fullname}`,
          };
          this.$data.options.push(option);
        });
      } else {
        CommonUtils.showError(response);
      }
    }
}
